import { createApp } from "vue";
import GlobalServiceNav from "./GlobalServiceNav.vue";
import "@coloplast/design-system/dist/components/nav/service/ds-nav-service.css";

const globalServiceNavMountElem = document.querySelector(
	'[data-feature="global-service-nav"]',
);

if (globalServiceNavMountElem) {
	const app = createApp({
		name: "GlobalServiceNavApp",
	});
	app.component("global-service-nav", GlobalServiceNav);
	app.mount(globalServiceNavMountElem);
}
